@if (form) {
  <div [formGroup]="form" class="form">
    <div class="flex flex-column gap-3 mb-3">
      <label for="label" class="font-semibold w-full"
        >{{ "admin.tenant_administration.tenant_form.tenant_name" | translate }}*</label
      >
      <input pInputText id="label" formControlName="label" autocomplete="off" />
    </div>
    <div class="flex flex-column gap-3 mb-3">
      <label for="noCoreLimit" class="font-semibold w-full">{{
        "admin.tenant_administration.tenant_form.no_core_limit" | translate
      }}</label>
      <p-inputNumber class="w-full" id="noCoreLimit" formControlName="noCoreLimit" />
      <!-- <input pInputText  autocomplete="off" /> -->
    </div>
    <ng-container formGroupName="address">
      <div class="flex flex-column gap-3 mb-3">
        <label for="street" class="font-semibold w-full"
          >{{ "admin.tenant_administration.tenant_form.tenant_street" | translate }}*</label
        >
        <input pInputText id="street" formControlName="street" autocomplete="off" />
      </div>
      <div class="flex flex-column gap-3 mb-3">
        <label for="number" class="font-semibold w-full"
          >{{ "admin.tenant_administration.tenant_form.tenant_number" | translate }}*</label
        >
        <input pInputText id="number" formControlName="number" autocomplete="off" />
      </div>
      <div class="flex flex-column gap-3 mb-3">
        <label for="zipCode" class="font-semibold w-full"
          >{{ "admin.tenant_administration.tenant_form.tenant_zipCode" | translate }}*</label
        >
        <input pInputText id="zipCode" formControlName="zipCode" autocomplete="off" />
      </div>
      <div class="flex flex-column gap-3 mb-3">
        <label for="city" class="font-semibold w-full"
          >{{ "admin.tenant_administration.tenant_form.tenant_city" | translate }}*</label
        >
        <input pInputText id="city" formControlName="city" autocomplete="off" />
      </div>
      <div class="flex flex-column gap-3 mb-3">
        <label for="country" class="font-semibold w-full">{{ "common.address.country" | translate }}*</label>
        <p-select id="country" formControlName="country" [options]="countries" class="w-full">
          <ng-template let-country #selectedItem>
            {{ country.label | translate }}
          </ng-template>
          <ng-template let-country #item>
            {{ country.label | translate }}
          </ng-template>
        </p-select>
        <!-- <input
          pInputText
          id="country"
          formControlName="country"
          autocomplete="off"
        /> -->
      </div>
    </ng-container>
    <div class="flex flex-column gap-3 mb-3">
      <label for="phoneNumber" class="font-semibold w-full">{{
        "admin.tenant_administration.tenant_form.tenant_phoneNumber" | translate
      }}</label>
      <input pInputText id="phoneNumber" formControlName="phoneNumber" autocomplete="off" />
    </div>
    <div class="flex flex-column gap-3 mb-3">
      <label for="emailAddress" class="font-semibold w-full">{{
        "admin.tenant_administration.tenant_form.tenant_emailAddress" | translate
      }}</label>
      <input pInputText id="emailAddress" formControlName="emailAddress" autocomplete="off" />
    </div>
    <div style="grid-column: 1 / 3" class="flex flex-column gap-3 mb-3">
      <label for="notes" class="font-semibold w-full">{{
        "admin.tenant_administration.tenant_form.tenant_notes" | translate
      }}</label>
      <textarea rows="5" cols="30" pInputTextarea formControlName="notes" [autoResize]="true"> </textarea>
      <!-- <input pInputText id="notes" formControlName="notes" autocomplete="off" /> -->
    </div>
    <div class="flex justify-content-end gap-2 g-col-2">
      <app-button buttonText="common.cancel" (click)="closeDialog()"></app-button>
      <app-button buttonText="common.save" [disabled]="!form.valid" (click)="save()"></app-button>
    </div>
  </div>
}
